import React from "react";
import {
  Div,
  Text2,
  Text3,
  InfoIcon,
  BigShadedButton,
  DownloadIcon
} from "components/Base";
import Loading from "ui-kit/Loading";

import { noop } from "utils/General";

const ImportBox = ({ children, onClick, selected = false }) => (
  <Div
    bg="#ffffff"
    bc={{
      hover: "#1E62D8",
      default: selected ? "#1E62D8" : "#E7E6EA"
    }}
    ba={1}
    height={1}
    display="row.center.center"
    bra={2}
    p={6}
    onClick={onClick}
    flex={1}
    style={{ flexBasis: 0 }}
  >
    {children}
  </Div>
);

const ImportFile = ({
  showImport = true,
  showCopy = false,
  showDownload = false,
  importText = "Upload a file to import",
  importCaption = "Choose a file...",
  copyText = "Copy & Paste",
  copyCaption = "Copy & paste just the CSV columns & rows that you need!",
  downloadButtonText = "Download Sample CSV",
  isOpeningImportModal = false,
  proTipText,
  downloadFile = noop,
  uploadFile = noop,
  downloadTemplate = noop
}) => {
  return (
    <Div display="column" width={1}>
      {proTipText ? (
        <Div
          bg="blue0"
          display="row.flex-start.center"
          style={{
            margin: "20px 24px 24px 24px",
            border: "1px solid #CCEDFF",
            borderRadius: "4px",
            padding: "16px 16px 16px 12px"
          }}
        >
          <InfoIcon
            color="gray8"
            size={24}
            style={{
              color: "#494949"
            }}
          />
          <Div
            ml={3}
            flex={1}
            style={{
              fontSize: "15px",
              color: "#343434"
            }}
          >
            <b>Pro Tip:</b> {proTipText}
          </Div>
        </Div>
      ) : null}

      <Div
        fw={4}
        style={{
          fontSize: "18px",
          color: "#343434",
          padding: proTipText ? "0px 24px 20px 24px" : "20px 24px 20px 24px"
        }}
      >
        Select an import option
      </Div>

      <Div
        style={{
          padding: "0 24px 24px 24px"
        }}
        display="column"
        height={195}
        width={1}
      >
        {isOpeningImportModal ? (
          <Loading />
        ) : (
          <Div display="row.space-between.center" height={1} width={1}>
            {(showImport && (
              <ImportBox
                selected={isOpeningImportModal}
                onClick={() => {
                  uploadFile();
                }}
              >
                <Div display="column.center.center" height={165}>
                  <span
                    className="material-icons"
                    style={{
                      fontSize: "48px",
                      color: "#1E62D8",
                      marginBottom: "16px"
                    }}
                  >
                    note_add
                  </span>
                  <Div
                    fw={4}
                    style={{
                      fontSize: "18px",
                      color: "#343434"
                    }}
                  >
                    {importText}
                  </Div>
                  <Div
                    textAlign="center"
                    maxWidth={320}
                    color="#494949"
                    style={{
                      marginTop: "6px",
                      fontSize: "14px"
                    }}
                  >
                    {importCaption}
                  </Div>
                </Div>
              </ImportBox>
            )) ||
              null}

            {(showCopy && (
              <React.Fragment>
                <Div width={20} />
                <ImportBox onClick={downloadFile}>
                  <Div height={200} display="column.center.center">
                    <span
                      className="material-icons"
                      style={{
                        fontSize: "48px",
                        color: "#868686",
                        marginBottom: "16px"
                      }}
                    >
                      content_paste
                    </span>
                    <Div
                      fw={4}
                      style={{
                        fontSize: "18px",
                        color: "#343434"
                      }}
                    >
                      {copyText}
                    </Div>
                    <Div
                      textAlign="center"
                      maxWidth={320}
                      color="#494949"
                      style={{
                        marginTop: "6px",
                        fontSize: "14px"
                      }}
                    >
                      {copyCaption}
                    </Div>
                  </Div>
                </ImportBox>
              </React.Fragment>
            )) ||
              null}
            {(showDownload && (
              <Div
                bg="neutral0"
                display="row.space-between.center"
                height={71}
                flex={1}
                bra={2}
                mt={6}
                pl={8}
                pr={3}
              >
                <Div>
                  <Text3 bold>Keep it clean, use our .csv template</Text3>
                  <Text2>This is safest way to import new records</Text2>
                </Div>
                <BigShadedButton
                  color="purple8"
                  bg="neutral3"
                  RightIcon={() => <DownloadIcon ml={3} />}
                  onClick={downloadTemplate}
                >
                  {downloadButtonText}
                </BigShadedButton>
              </Div>
            )) ||
              null}
          </Div>
        )}
      </Div>
    </Div>
  );
};

export default ImportFile;
